import styles from './Tabs.module.scss'

interface TabsProps<T> {
  className?: string
  data: T[]
  onTabSelect: (selected: T) => void
  renderContent: (item: T, selected: boolean) => JSX.Element
  selected: T
}

const Tabs = <T,>({ className, data, onTabSelect, renderContent, selected }: TabsProps<T>) => (
  <ul className={[styles.tabs, className].join(' ')} data-testid="tabs">
    {data.map((item, index) => (
      <li
        className={item === selected ? styles.selected : undefined}
        key={index}
        onClick={() => onTabSelect(item)}
      >
        {renderContent(item, item === selected)}
      </li>
    ))}
  </ul>
)

export default Tabs
